import React from 'react';

export default function CustomIcon({ stroke = 'black', ...rest }: React.SVGProps<SVGSVGElement>) {
    return (
        <svg width="800px" height="800px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M21 8V16C21 18.7614 18.7614 21 16 21H8C5.23858 21 3 18.7614 3 16V8C3 5.23858 5.23858 3 8 3H16C18.7614 3 21 5.23858 21 8Z"
                stroke={stroke}
                strokeWidth="1.5"
                strokeLinecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M10 12C8.34315 12 7 13.3431 7 15C7 16.6569 8.34315 18 10 18C11.6569 18 13 16.6569 13 15V6C13.3333 7 14.6 9 17 9"
                stroke={stroke}
                strokeWidth="1.5"
                strokeLinecap="round"
                stroke-linejoin="round"
            />
        </svg>
    );
}
